import {
  breadcrumbDynamicStructuredData,
  breadcrumbStructuredData,
} from "../../../sections/Breadcrumb/Breadcrumb.structuredData";
import type { BlockStructuredDataResolver } from "../types";

/**
 * Blocos que declaram os próprios nós, por nome do wrapper — a mesma chave do
 * switch do `Node.tsx` e do `LISTING_LINK_BY_TYPE`.
 *
 * Um bloco novo é um arquivo ao lado da section e uma linha aqui. Nada além
 * disso conhece a lista, e o catálogo do CMS não participa: a forma é fixa do
 * bloco, não configurável no admin.
 */
export const BLOCK_STRUCTURED_DATA_BY_TYPE: Record<
  string,
  BlockStructuredDataResolver
> = {
  BreadcrumbWrapper: breadcrumbStructuredData,
  BreadcrumbDynamicWrapper: breadcrumbDynamicStructuredData,
};
